import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { setFormErrors } from "@/lib/react-form-utils";
import { type Area } from "@/services/AreaService";
import { useEffect } from "react";
import { useForm, type SubmitHandler } from "react-hook-form";

interface AreaFormProps {
    initialData: Area;
    onSubmit: (data: Omit<Area, "id">) => Promise<Record<string, string> | null>;
}

const AreaForm: React.FC<AreaFormProps> = ({ initialData, onSubmit, }) => {
  const { register, handleSubmit, formState: { isDirty, errors }, reset, setError } = useForm<Omit<Area, "id">>({defaultValues: initialData});

  const handleFormSubmit: SubmitHandler<Omit<Area, "id">> = async (data) => {
    setFormErrors({}, setError, data); // Clear previous errors
    data.tenantId = initialData.tenantId;
    const serverErrors = await onSubmit(data);
    if (serverErrors) {
      setFormErrors<Omit<Area, "id">>(serverErrors, setError, data);
    }
    reset(data);
  };

  useEffect(() => {
    reset(initialData);
  }, [initialData, reset]);

  return (
      <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
        <div>
          <Label
            htmlFor="name"
          >
            Name *
          </Label>
          <Input
            type="text"
            {...register("name", { required: 'Name is required'})}
          />
          <span className="text-sm text-red-500">{errors.name?.message}</span>
        </div>
        <div>
          <Label
            htmlFor="description"
          >
            Description
          </Label>
          <Input
            type="text"
            {...register("description")}
          />
          <span className="text-sm text-red-500">{errors.description?.message}</span>
        </div>        
        <div className="flex justify-end space-x-2">
          <button
            type="button"
            onClick={() => reset()}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Cancel
          </button>
          <Button
            type="submit"
            disabled={!isDirty}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Update Area
          </Button>
        </div>
      </form>
  );
};

export default AreaForm;
